import { apiClient, extractData } from './client';
import type { Project, ProjectPlan, PipelineStage } from '@/types';

export const projectsApi = {
  list: () => apiClient.get<{ data: Project[] }>('/projects').then(extractData),
  get: (id: string) => apiClient.get<{ data: Project }>(`/projects/${id}`).then(extractData),
  create: (data: Partial<Project>) =>
    apiClient.post<{ data: Project }>('/projects', data).then(extractData),
  update: (id: string, data: Partial<Project>) =>
    apiClient.patch<{ data: Project }>(`/projects/${id}`, data).then(extractData),
  delete: (id: string) => apiClient.delete(`/projects/${id}`),

  // Plans
  listPlans: (projectId: string) =>
    apiClient.get<{ data: ProjectPlan[] }>(`/projects/${projectId}/plans`).then(extractData),
  createPlan: (projectId: string, data: Partial<ProjectPlan>) =>
    apiClient.post<{ data: ProjectPlan }>(`/projects/${projectId}/plans`, data).then(extractData),
  updatePlan: (projectId: string, planId: string, data: Partial<ProjectPlan>) =>
    apiClient.patch<{ data: ProjectPlan }>(`/projects/${projectId}/plans/${planId}`, data).then(extractData),
  deletePlan: (projectId: string, planId: string) =>
    apiClient.delete(`/projects/${projectId}/plans/${planId}`),

  // Stages
  listStages: (projectId: string) =>
    apiClient.get<{ data: PipelineStage[] }>(`/projects/${projectId}/stages`).then(extractData),
  createStage: (projectId: string, data: Partial<PipelineStage>) =>
    apiClient.post<{ data: PipelineStage }>(`/projects/${projectId}/stages`, data).then(extractData),
  updateStage: (projectId: string, stageId: string, data: Partial<PipelineStage>) =>
    apiClient.patch<{ data: PipelineStage }>(`/projects/${projectId}/stages/${stageId}`, data).then(extractData),
  deleteStage: (projectId: string, stageId: string) =>
    apiClient.delete(`/projects/${projectId}/stages/${stageId}`),
};
